module.exports = __webpack_public_path__ + "static/media/home_3.373aef72.jpg";